import Marquee from "react-fast-marquee";

const ITEMS = [
  "Sea Views from Every Room",
  "Complimentary Temple Shuttle",
  "Seafront Location",
  "AC Accommodations",
  "High-Speed Wi-Fi",
  "Operated by Shree Somnath Trust",
];

export default function EditorialMarquee() {
  return (
    <div data-testid="editorial-marquee" className="overflow-hidden border-y border-gold/20 bg-navy py-5">
      <Marquee speed={35} gradient={false} pauseOnHover>
        {ITEMS.map((item) => (
          <span key={item} className="mx-8 flex items-center gap-8 font-display text-lg italic text-gold/90">
            {item}
            <span className="inline-block h-1.5 w-1.5 rotate-45 bg-gold/50" />
          </span>
        ))}
      </Marquee>
    </div>
  );
}
